import { opaccAjaxPlugin } from '../opacc.static.js';
import { OpaccBasket } from './opacc.class.basket.js';

/** @module basket */

/**
 *  Zahlungsoptionen im Checkout bereitstellen und überprüfen
 *
 * @extends {OpaccBasket}
 */
export class OpaccBasketPayment extends OpaccBasket {
	constructor() {
		super();
		this.attachEventListener();
	}

	/**
	 *
	 *
	 */
	attachEventListener() {
		if (this.wrapperElement) {
			this.wrapperElement.addEventListener('click', e => {
				let button = e.target.closest('.opc-payment-infos .opc-radio > label');
				if(button) {
					let parent = button.closest('.opc-payment-infos');
					let targetId = parent.closest('.payment-selection').dataset.opHref;
					let allOptions = parent.querySelectorAll('input');
					let selectedOption = button.parentNode.querySelector('input');
					Array.from(allOptions).forEach(item => {
						item.removeAttribute('checked');
					});
					if(selectedOption) {
						selectedOption.setAttribute('checked', 'checked');
						let data = {
							type: 'basket',
							action: 'payment',
							paymentType: selectedOption.value,
							pluginId: 'paymentType'
						};

                        let url = opaccAjaxPlugin.setAsyncUrl();
						opaccAjaxPlugin.fetchAsynPostForm(url, data, this.refreshContent.bind(this, targetId), this.asyncErrorHandler.bind(this), true);
					}
				}
			}, false);
		}
	}
}